import React from "react";
import { FaCheck, FaMinus } from "react-icons/fa";
import { GoDotFill } from "react-icons/go";
import { RxCross2 } from "react-icons/rx";

const ZoomStatusLegend = () => {
  return (
    <div
      className="alert alert-info border border-2 border-black text-black alert-dismissible fade show py-0 mb-2 me-2"
      role="alert"
    >
      <div className="d-flex align-items-center gap-2 px-2 py-1 rounded fst-italic">
        <span className="text-danger pe-1 fw-bold border-bottom border-white">
          Note:
        </span>
        <small className="fw-semibold"> Zoom Status:</small>

        <div className="d-flex align-items-center gap-2">
          <span className="status-circle bg-secondary-subtle text-black">
            <FaMinus size={8} color="black" />
          </span>
          <small>Not Attended</small>
        </div>

        <div className="d-flex align-items-center gap-2">
          <span className="status-circle bg-success text-white">
            <FaCheck size={8} />
          </span>
          <small>Attended</small>
        </div>

        <div className="d-flex align-items-center gap-2">
          <span className="status-circle bg-secondary-subtle text-secondary">
            <GoDotFill size={20} />
          </span>
          <small>Registered</small>
        </div>
      </div>
      <button
        type="button"
        className="btn-close fs-4 text-black "
        data-bs-dismiss="alert"
        aria-label="Close"
        style={{ position: "absolute", top: "-12px" }}
      >
        <RxCross2 />
      </button>
    </div>
  );
};

export default ZoomStatusLegend;
